import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Stack, TextField } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { useState } from "react";
import DataArrayIcon from '@mui/icons-material/DataArray';
import DateComIntervalo from "../DateComIntervalo";
import { Column, TFilters } from "./types";
import { cleanDynFilter, pegarItemPeloPrefixo } from "./helpers";

export default function DialogHeadFilters<T>({
    open,
    value,
    filters,
    handleClose,
    handleChangeFilter
}: DialogFiltersProps<T>) {

    const [dialogFilters, setDialogFilters] = useState<TFilters>(pegarItemPeloPrefixo(filters, value.id as string) as TFilters)
    const [contem, setContem] = useState<string>('')

    const identifier = value.id as string

    const handleChangeProp = (prop: string, value: any) => {
        setDialogFilters(prevState => ({
            ...prevState,
            [prop]: value
        }))
    }

    const handleSubmit = () => {
        if (contem !== "") {
            const prevValue = dialogFilters[`${identifier}_contem`] || [];
            prevValue.push(contem)

            const updatedFilters = {
                ...dialogFilters,
                [`${identifier}_contem`]: prevValue
            };

            setDialogFilters(updatedFilters)

            handleChangeFilter({
                ...filters,
                ...updatedFilters
            })

            setContem("")
        } else {
            handleChangeFilter({
                ...filters,
                ...dialogFilters
            })
        }

        handleClose()
    }

    const handleCleanFilter = () => {
        const cleanObj = cleanDynFilter(value.id as string, value.type)
        handleChangeFilter({
            ...filters,
            ...cleanObj
        })
        handleClose()
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll="body"
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                Filtro {value.label}
            </DialogTitle>

            <DialogContent>
                {
                    value.type === "text" &&
                    <>
                        <Box display="flex" alignItems="center" my={1} gap={2}>
                            <SearchIcon />
                            <TextField
                                value={dialogFilters[`${identifier}_pesquisar`]}
                                fullWidth
                                label="Palavra-chave"
                                variant="outlined"
                                onChange={({ target }) => handleChangeProp(`${identifier}_pesquisar`, target.value)}
                            />
                        </Box>

                        <Box display="flex" alignItems="center" mb={1} mt={2} gap={2}>
                            <DataArrayIcon />
                            <FormControl fullWidth>
                                <TextField
                                    label="Contém"
                                    variant="outlined"
                                    onChange={({ target }) => setContem(target.value)}
                                    onKeyDown={(event: any) => {
                                        if (event.key === 'Enter') {
                                            const prevValue = dialogFilters[`${identifier}_contem`] || []
                                            prevValue.push(event.target.value)
                                            handleChangeProp(`${identifier}_contem`, prevValue);
                                            event.target.value = ""
                                            setContem("")
                                        }
                                    }}
                                />
                                <FormHelperText>Aperte ENTER para inserir o valor</FormHelperText>
                            </FormControl>
                        </Box>

                        <>
                            {
                                (dialogFilters[`${identifier}_contem`] && dialogFilters[`${identifier}_contem`]?.length > 0) &&
                                <Stack direction="row" flexWrap="wrap" gap={1} spacing={0.5} ml={5} mt={2}>
                                    {dialogFilters[`${identifier}_contem`].map((i: string, index: number) => (
                                        <Chip label={i} onDelete={() => {
                                            const newValue =
                                                dialogFilters[`${identifier}_contem`].filter((_: string, i: number) => i !== index);

                                            handleChangeProp(`${identifier}_contem`, newValue);
                                        }} />
                                    ))}
                                </Stack>
                            }
                        </>
                    </>
                }

                {
                    value.type === "date" &&
                    <Box display="flex" alignItems="center" my={1} gap={2}>
                        <CalendarTodayIcon />
                        <DateComIntervalo
                            icon={false}
                            data={{
                                inicial: dialogFilters[`${identifier}_inicio`],
                                final: dialogFilters[`${identifier}_fim`]
                            }}
                            onChangeData={(data) => {
                                handleChangeProp(`${identifier}_inicio`, data.inicial)
                                handleChangeProp(`${identifier}_fim`, data.final)
                            }}
                            datePickerView={['year', 'month', 'day']}
                            formatString="DD/MM/YYYY"
                            labelInput="Periodo"
                        />
                    </Box>
                }

                {
                    (value.type === "number" || value.type === "monetary") &&
                    <>
                        <Box display="flex" alignItems="center" my={1} gap={2}>
                            <KeyboardArrowRightIcon />
                            <TextField
                                fullWidth
                                value={dialogFilters[`${identifier}_maior_igual`]}
                                label="Maior ou igual a"
                                variant="outlined"
                                type="number"
                                onChange={({ target }) => handleChangeProp(`${identifier}_maior_igual`, target.value)}
                            />
                        </Box>

                        <Box display="flex" alignItems="center" my={1} gap={2}>
                            <KeyboardArrowLeftIcon />
                            <TextField
                                fullWidth
                                value={dialogFilters[`${identifier}_menor_igual`]}
                                label="Menor ou igual a"
                                variant="outlined"
                                type="number"
                                onChange={({ target }) => handleChangeProp(`${identifier}_menor_igual`, target.value)}
                            />
                        </Box>
                    </>
                }
            </DialogContent>

            <DialogActions>
                <Button
                    variant="text"
                    onClick={handleCleanFilter}
                >
                    Limpar
                </Button>
                <Button
                    autoFocus
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Filtrar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogFiltersProps<T> {
    open: boolean,
    value: Column<T>,
    handleClose: () => void,
    filters: TFilters,
    handleChangeFilter: (values: TFilters) => void,
}

//